import { useFormikContext } from 'formik'

export function useData() {
  const { isSubmitting } = useFormikContext()

  // SH-1428 (E5): block Save only while a submit is in flight, to prevent
  // double-submits. Intentionally NOT `!isValid` — clicking Save while invalid
  // is what surfaces all required-field errors (handleSaveClick -> setTouched),
  // so disabling on invalid would hide them (breaks the required-field flow).
  return {
    disableSave: isSubmitting,
  }
}
